import React from 'react';
import Ask from '../Ask/Ask';
import getPermission from './getPermission';
import subscribeUserToPush from './subscribeUserToPush';
import sendSubscriptionToBackEnd from './sendSubscriptionToBackEnd';

const AskNotifPermission = () => {
  const setupNotification = () => {
    getPermission()
      .then((permissionResult) => {
        if (permissionResult === 'granted') {
          subscribeUserToPush()
            .then((pushSubscription) => {
              sendSubscriptionToBackEnd(pushSubscription)
                .then((res) => {
                  if (res.ok) {
                    localStorage.setItem('notificationPermission', permissionResult);
                  }
                });
            });
        }
      });
  };

  return <Ask
      question={ 'Do you want to be notified about the latest features and university news update' }
      action={ setupNotification }
    />;
};

export default AskNotifPermission;
